import { render, staticRenderFns } from "./MenuKitComponent.vue?vue&type=template&id=44c9b1bc&scoped=true&"
import script from "./MenuKitComponent.vue?vue&type=script&lang=js&"
export * from "./MenuKitComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c9b1bc",
  null
  
)

export default component.exports